import { TABLE_MODEL } from './groupMetricsTable.model';
import { metricNames } from '@linearb/linjs-common';
import moment from 'moment';

export const TREND_DIRECTIONS = {
  UP: 'Up',
  DOWN: 'Down',
  SAME: 'Same'
};

export const UNIT_TYPES = {
  PERCENTAGE: 'percentage',
  COUNT: 'count',
  NON_AVG_COUNT: 'nonAvgCount',
  TIME_SPAN: 'timespan'
};

// cells that are always in use
export const CONSTANT_CELLS = [TABLE_MODEL.TEAM_NAME, TABLE_MODEL.MEMBERS];

export const NUM_METRICS_TO_SELECT = 4;

export const PREVIOUS_PERIODS = {
  ITERATIONS: {
    periodKey: 'ITERATIONS'
  },
  PAST_7_DAYS: {
    periodKey: 'PAST_7_DAYS',
    after: moment().subtract(14, 'days'),
    before: moment().subtract(7, 'days')
  },
  PAST_30_DAYS: {
    periodKey: 'PAST_30_DAYS',
    after: moment().subtract(60, 'days'),
    before: moment().subtract(30, 'days')
  },
  MONTH_TO_DATE: {
    periodKey: 'MONTH_TO_DATE',
    after: moment().startOf('month').subtract(1, 'months'),
    before: moment().subtract(1, 'days').subtract(1, 'months')
  },
  PAST_3_MONTHS: {
    periodKey: 'PAST_3_MONTHS',
    after: moment().subtract(6, 'months'),
    before: moment().subtract(3, 'months')
  }
};

// each metric has different color indication per direction
export const METRICS_COLOR_PER_DIRECTION = {
  [metricNames.CYCLE_TIME]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.TIME_TO_PR]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.TIME_TO_REVIEW]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.REVIEW_TIME]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.TIME_TO_PROD]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.PR_SIZE]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.REVIEW_DEPTH]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.NEW_WORK]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.REFACTOR]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.REWORK]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.PR_MERGED_WITHOUT_REVIEW]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.COMMIT_CODE_CHANGES]: {
    Up: { color: 'radicalRed' },
    Down: { color: 'malachite' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.COMMIT_COUNT]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.PR_NEW]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.PR_MERGED]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.REVIEWS]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.RELEASES_COUNT]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.ACTIVE_DAYS]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.DONE_BRANCHES]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  },
  [metricNames.ACTIVE_BRANCHES]: {
    Up: { color: 'malachite' },
    Down: { color: 'radicalRed' },
    Same: { color: 'catskillWhite' }
  }
};

export const TABLE_PAGE_SIZE = 25;
